var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        [
          _c("h3", [_vm._v(_vm._s(_vm.summary.surveyName))]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                { attrs: { title: "Summary", active: "" } },
                [
                  _c(
                    "b-container",
                    { staticClass: "pt-5" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-container",
                                { staticClass: "pl-0 pr-0 pb-0 pt-0" },
                                [
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "text-left mb-4 border-bottom"
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            "\n                  Programme\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.summary.programmeName) +
                                            "\n                "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "text-left mb-4 border-bottom"
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            "\n                  Customer\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.summary.customerName) +
                                            "\n                "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "text-left mb-4 border-bottom"
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            "\n                  Primary/Secondary Industry\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.summary.customerIndustry
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.summary
                                                .customerSecondaryIndustry
                                                ? "/"
                                                : ""
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.summary
                                                .customerSecondaryIndustry
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "text-left mb-4 border-bottom"
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            "\n                  Country/Region\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.summary.customerCountry
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.summary.customerRegion
                                                ? "-"
                                                : ""
                                            ) +
                                            " " +
                                            _vm._s(_vm.summary.customerRegion) +
                                            "\n                "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              this.summary.overallScore
                                ? _c("Gauge", {
                                    attrs: {
                                      width: 400,
                                      height: 240,
                                      "chart-data": parseFloat(
                                        this.summary.overallScore
                                      ).toFixed(2),
                                      programme: this.summary.programmeName
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "text-left mb-4 border-bottom" },
                        [
                          _c("b-col", { staticClass: "font-weight-bold" }, [
                            _vm._v("\n            Period/Year\n          ")
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.summary.period) +
                                " " +
                                _vm._s(_vm.summary.year) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { cols: "3" }
                            },
                            [_vm._v("\n            Overall Score\n          ")]
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  parseFloat(this.summary.overallScore).toFixed(
                                    2
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "text-left mb-4 border-bottom" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { cols: "3" }
                            },
                            [
                              _vm._v(
                                "\n            Total Responses\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.summary.totalResponses) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { cols: "3" }
                            },
                            [
                              _vm._v(
                                "\n            Average Comments\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  parseFloat(
                                    this.summary.averageComments
                                  ).toFixed(2)
                                ) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "text-left mb-4 border-bottom" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { cols: "3" }
                            },
                            [
                              _vm._v(
                                "\n            Number of Staff/Units\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.summary.number_of_staff > 0
                                    ? _vm.summary.number_of_staff + " staff"
                                    : ""
                                ) +
                                "\n            " +
                                _vm._s(
                                  _vm.summary.number_of_staff > 0 &&
                                  _vm.summary.number_of_units > 0
                                    ? ", "
                                    : ""
                                ) +
                                "\n            " +
                                _vm._s(
                                  _vm.summary.number_of_units > 0
                                    ? _vm.summary.number_of_units + " units"
                                    : ""
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { cols: "3" }
                            },
                            [_vm._v("\n            Sponsor\n          ")]
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.summary.sponsor) +
                                " " +
                                _vm._s(
                                  _vm.summary.sponsor_contact_number
                                    ? "(" +
                                      _vm.summary.sponsor_contact_number +
                                      ")"
                                    : ""
                                ) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "text-left mb-4 border-bottom" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { cols: "3" }
                            },
                            [_vm._v("\n            Areas\n          ")]
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.summary.area) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { cols: "3" }
                            },
                            [_vm._v("\n            Gatekeeper\n          ")]
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.summary.gatekeeper) +
                                " " +
                                _vm._s(
                                  _vm.summary.gatekeeper_contact_number
                                    ? "(" +
                                      _vm.summary.gatekeeper_contact_number +
                                      ")"
                                    : ""
                                ) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "text-left mb-4 border-bottom" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { cols: "3" }
                            },
                            [_vm._v("\n            External POC\n          ")]
                          ),
                          _vm._v(" "),
                          _vm.external_poc
                            ? _c(
                                "b-col",
                                { staticClass: "font-weight-bold" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "check" }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "text-left mb-4 border-bottom" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { cols: "3" }
                            },
                            [_vm._v("\n            Accreditations\n          ")]
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.summary.accreditations)
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { cols: "3" }
                            },
                            [_vm._v("\n            Customisation\n          ")]
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.summary.customization)
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Recommendations" } },
                [
                  _vm.summary.surveyRunId
                    ? _c("recommendations-list", {
                        attrs: { "survey-run-id": _vm.summary.surveyRunId }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Quick Wins" } },
                [
                  _vm.summary.surveyRunId
                    ? _c("quick-wins-list", {
                        attrs: { "survey-run-id": _vm.summary.surveyRunId }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Comments" } },
                [
                  !_vm.loading
                    ? _c("comments-list", {
                        attrs: { "survey-runs": [_vm.summary] }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c("survey-analysis", { attrs: { "survey-runs": [_vm.summary] } })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a7a628", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a7a628","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveySummary.vue
// module id = null
// module chunks = 